import Icon from '@ant-design/icons';
import React from 'react';
import { ReactComponent as IconSvg } from '../../assets/ArrowRight.svg';

export const ArrowRight = (props: React.ComponentProps<typeof Icon>) => {
  return <Icon component={IconSvg} {...props} />;
};
